// import type { DemandeDTO } from '@/features/api/extranet/dto/Demande/shared'
// import { naturesFichiersAf } from '@/features/domaine/regles-akto/AF'
// import { naturesFichiersCapp } from '@/features/domaine/regles-akto/CAPP'
// import { naturesFichiersCar } from '@/features/domaine/regles-akto/CAR'
// import { naturesFichiersCpro } from '@/features/domaine/regles-akto/CPRO'
// import { naturesFichiersCxpi } from '@/features/domaine/regles-akto/CXPI/naturesFichiers.ts'
// import { naturesFichiersDR } from '@/features/domaine/regles-akto/DR'
// import { naturesFichiersOutilFpe } from '@/features/domaine/regles-akto/OUTILFPE'
// import { naturesFichiersProa } from '@/features/domaine/regles-akto/PROA'
// import { naturesFichiersProforma } from '@/features/domaine/regles-akto/PROFORMA'
// import { type NaturesFichierProvider } from '@/features/domaine/types/opco'
import type { App } from 'vue'

// Todo : Injecter dépendances globale App ici
export default {
  install(_app: App<Element>) {
    // Natures fichier
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersCapp.key, naturesFichiersCapp)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersAf.key, naturesFichiersAf)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersCpro.key, naturesFichiersCpro)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersProa.key, naturesFichiersProa)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersCxpi.key, naturesFichiersCxpi)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersDR.key, naturesFichiersDR)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersProforma.key, naturesFichiersProforma)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersOutilFpe.key, naturesFichiersOutilFpe)
    // app.provide<NaturesFichierProvider<DemandeDTO>>(naturesFichiersCar.key, naturesFichiersCar)
  },
}
